module.exports = __webpack_public_path__ + "static/wordpress-69a103aec21b1282cda434f223970398.png";